import Router from "next/router";

import { CardButton } from "@/components/Card/CardButton";
import { Card, CardContent, CardMedia, Divider, Stack, Typography } from "@mui/material";

import { styles } from "./styles";
import { DefaultRedeemMilesPartnerCardProps } from "./types";

export const DefaultRedeemMilesPartnerCard: React.FC<DefaultRedeemMilesPartnerCardProps> = (props) => {
  const destinationURL = `/categoria/${props.categoryId}/parceiro/${props.partnerId}/informativo`;

  return (
    <Card
      onClick={() => {
        Router.push(destinationURL);
      }}
      sx={{
        flexDirection: "column",
        minHeight: "170px",
        cursor: "pointer",
        borderRadius: "16px",
        height: "100%",
        maxWidth: { xs: "100%", sm: "282px" },
        display: "flex"
      }}
    >
      <CardMedia
        component="img"
        src={props.image || "/placeholder.png"}
        alt="Imagem do card"
        width="100%"
        height="208.28px"
        sx={{ px: 6 }}
        style={{ alignSelf: "start", objectFit: "contain", flex: "1 0 auto", maxHeight: "208.28px" }}
      />

      <CardContent sx={{ display: "flex", flexDirection: "column", px: "16px !important", pt: "20px", pb: "31px !important", flex: 1 }}>
        <Typography css={styles.partner}>{props.partnerName}</Typography>

        <Stack justifyContent="space-between">
          <Divider
            sx={{
              borderColor: "#0000001F",
              my: "16px"
            }}
          />
          <CardButton title="Troque agora" buttonUrl={destinationURL} parentPartnerName={props.partnerName} />
        </Stack>
      </CardContent>
    </Card>
  );
};
